import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';
import AggsoilSpecimenPreparationSection from './AggsoilSpecimenPreparationSection';
import AsphaltSpecimenPreparationSection from './AsphaltSpecimenPreparationSection';

let SpecimenPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isAsphaltTest = useSelector(createWorksheetSelector!('Preparation.IsAsphaltTest'));

  return (
    <PageSection heading="Specimen Preparation">
      {isAsphaltTest ? <AsphaltSpecimenPreparationSection /> : <AggsoilSpecimenPreparationSection />}
    </PageSection>
  );
};

SpecimenPreparationPageSection = withInjectedProps(SpecimenPreparationPageSection);

export { SpecimenPreparationPageSection };
export default SpecimenPreparationPageSection;
